<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <br />
      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="data"
        @click-buscar="buscar"
        @click-event="clickEvent"
        pagination
        filtro
        showExportToExcel
        :perPage="perPage"
        :dataLength="dataLength"
      >
        <table-column
          slot="label"
          :label="'Cédula'"
          v-bind:value="'cedula'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Pagaré'"
          v-bind:value="'pagare'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Modelo'"
          v-bind:value="'modelo'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Código'"
          v-bind:value="'convenio'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Valor'"
          v-bind:value="'valor'"
          :filter="'numberFormat'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha Reclamación'"
          v-bind:value="'fecha_reclamacion'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha Pago'"
          v-bind:value="'fecha_pago'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Estado'"
          v-bind:value="'estado'"
        ></table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";

import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      perPage: 10,
      informe_url: "portal/informes/devolucion",
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      filename: "Devoluciones ",
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      SelectFiltroTabla: "pages/SelectFiltroTabla",
      loading: "loading",
    }),
    dataLength() {
      return this.$store.getters["pages/total"];
    },
    data() {
      return this.$store.getters["pages/dataInformes"];
    },
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    buscar(event) {
      this.loadData();
    },
    async clickEvent(data, slug) {
      this.perPage = data.nRows;
      switch (slug) {
        case "paginacion":
          this.loadData(data.nRows, data.page);
          break;
        case "export-to-excel":
          this.$toasted.show("Por favor espere mientras exportamos los datos", {
            theme: "toasted-primary",
            position: "top-center",
            duration: 5000,
          });
          this.$store.commit("SET_LOADING", true);
          try {
            let response = await this.$store.state.api.get(
              this.informe_url,
              {
                params: {
                  paginar: 0,
                },
              }
            );
            let data = XLSX.utils.json_to_sheet(response.data.datos, {
              header: [
                "cedula",
                "pagare",
                "modelo",
                "convenio",
                "valor",
                "fecha_reclamacion",
                "fecha_pago",
                "estado",
              ],
            });
            data["A1"].v = "Cédula";
            data["B1"].v = "Pagaré";
            data["C1"].v = "modelo";
            data["D1"].v = "Código";
            data["E1"].v = "Valor";
            data["F1"].v = "Fecha Reclamación";
            data["G1"].v = "Fecha de Pago";
            data["H1"].v = "Estado";

            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, data, this.fileName);
            var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            var wbout = XLSX.write(workbook, wopts);
            var today = new Date();
            var dd = today.getDate();

            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();

            if (dd < 10) {
              dd = "0" + dd;
            }

            if (mm < 10) {
              mm = "0" + mm;
            }

            today = dd + "/" + mm + "/" + yyyy;
            saveAs(
              new Blob([wbout], { type: "application/octet-stream" }),
              this.filename + today + ".xlsx"
            );
            this.$toasted.show("El archivo fue exportado exitosamente", {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            });
          } catch (err) {
            this.$toasted.show(
              "Ocurrió un error al intentar exportar el archivo",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }
          this.$store.commit("SET_LOADING", false);
          break;
        default:
          break;
      }
    },
    loadData(row, page, paginar = 1) {
      this.$store.dispatch("pages/fetch", {
        endpoint: this.informe_url,
        params: {
          row: this.perPage,
          page: page ? page : 1,
          paginar: paginar,
        },
      });
    },
  },
  mounted() {
    this.loadData(this.perPage, 1);
  },
};
</script>